/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import {useIntl} from 'react-intl'
import {KTIcon} from '../../../../helpers'
import {SidebarMenuItemWithSub} from './SidebarMenuItemWithSub'
import {SidebarMenuItem} from './SidebarMenuItem'

const SidebarMenuMain = () => {
  const intl = useIntl()

  return (
    <>
      <SidebarMenuItem
        to='admin/dashboard'
        icon='element-11'
        title={intl.formatMessage({id: 'MENU.DASHBOARD'})}
        fontIcon='bi-app-indicator'
      />

      <SidebarMenuItem
        to='admin/apps/user-management/users'
        icon='abstract-28'
        title='User List'
        fontIcon='bi-person'
      />

      <SidebarMenuItem
        to='admin/plugins'
        icon='abstract-28'
        title={intl.formatMessage({id: 'MENU.PLUGINS'})}
        fontIcon='bi-layers'
      />
    </>
  )
}

export {SidebarMenuMain}
